export const RECEIVE_TRAIN_POSITION = 'RECEIVE_TRAIN_POSITION'
export const RECEIVE_NOTIFICATION = 'RECEIVE_NOTIFICATION'
export const RECEIVE_STATION_DETAIL = 'RECEIVE_STATION_DETAIL'
export const RECEIVE_TRAIN_DETAIL = 'RECEIVE_TRAIN_DETAIL'
export const CLOSE_TRAIN_MODAL = 'CLOSE_TRAIN_MODAL'
export const CLOSE_TRANSFER_MODAL = 'CLOSE_TRANSFER_MODAL'
export const CLOSE_TRAIN_OPERATION = 'CLOSE_TRAN_OPERATION'
export const NEXT_NOTIFICATION = 'NEXT_NOTIFICATION'
export const LINE_REVERSE = 'LINE_REVERSE'
export const CLOSE_STATION_DETAIL = 'CLOSE_STATION_DETAIL'
export const LOADED_DELAY_CERTIFICATES = 'LOADED_DELAY_CERTIFICATES'
export const LOADED_ANNOUNCEMENT = 'LOADED_ANNOUNCEMENT'
export const RECEIVE_LINES = 'RECEIVE_LINES'
export const RECEIVE_MAINTENANCE = 'RECEIVE_MAINTENANCE'
export const RECEIVE_STATION_ID = 'RECEIVE_STATION_ID'
export const RECEIVE_LOCATION_DATA = 'RECEIVE_LOCATION_DATA'
export const RECEIVE_CURRENT_CONGESTION_RATE = 'RECEIVE_CURRENT_CONGESTION_RATE'
export const RECEIVE_CONGESTION_TREND = 'RECEIVE_CONGESTION_TREND'
export const CHANGE_TIMETABLE_COLLAPSED = 'CHANGE_TIMETABLE_COLLAPSED'
export const SET_THEME = 'SET_THEME'
export const SET_OS = 'SET_OS'
export const SET_POPINFO_ID = 'SET_POPINFO_ID'
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS'
export const RECEIVE_USER_SETTINGS = 'RECEIVE_USER_SETTINGS'
export const RECEIVE_RESTROOMS = 'RECEIVE_RESTROOMS'
export const RECEIVE_TRAIN_ICON_SETTINGS = 'RECEIVE_TRAIN_ICON_SETTINGS'

const API_BASE_URL = process.env.API_BASE_URL
const API_LAMBDA_URL = process.env.API_LAMBDA_URL
const EXTERNAL_DATA_BASE_URL = process.env.EXTERNAL_DATA_BASE_URL
const CUSTOM_DATA_BASE_URL = process.env.CUSTOM_DATA_BASE_URL
const STATION_VIEW_DATA_BASE_URL = 'https://external-data.nankaiapp.com'
const API_RESTROOM_URL = process.env.API_RESTROOM_URL
const API_RESTROOM_KEY = process.env.API_RESTROOM_KEY
const API_RESTROOM_TARGET = process.env.API_RESTROOM_TARGET

export const receiveTrainPosition = payload => ({
  type: RECEIVE_TRAIN_POSITION,
  payload,
})

export const receiveNotification = payload => ({
  type: RECEIVE_NOTIFICATION,
  payload,
})

export const receiveStationDetail = payload => ({
  type: RECEIVE_STATION_DETAIL,
  payload,
})

export const receiveSingleTrain = payload => ({
  type: RECEIVE_TRAIN_DETAIL,
  payload,
})

export const closeTrainModal = () => ({
  type: CLOSE_TRAIN_MODAL,
  train_kind_name: null,
  departure_station_name: null,
  arrival_station_name: null,
  station_infos: [],
})

export const closeTransferModal = () => ({
  type: CLOSE_TRANSFER_MODAL,
})

export const closeTrainOperation = () => ({
  type: CLOSE_TRAIN_OPERATION,
  showingOperation: true,
})

export const nextNotification = () => ({
  type: NEXT_NOTIFICATION,
  showingNext: true,
})

export const lineReverse = () => ({
  type: LINE_REVERSE,
  reverseFlag: true,
})

export const closeStationDetail = () => ({
  type: CLOSE_STATION_DETAIL,
  up: null,
  down: null
})

export const receiveLines = (payload) => ({
  type: RECEIVE_LINES,
  payload
})

export const receiveMaintenance = (payload) => ({
  type: RECEIVE_MAINTENANCE,
  payload
})

export const receiveLocationData = (payload, locationId) => ({
  type: RECEIVE_LOCATION_DATA,
  locationId,
  payload,
})

export const receiveCurrentCongestionRate = (payload, locationId) => ({
  type: RECEIVE_CURRENT_CONGESTION_RATE,
  locationId,
  payload,
})

export const receiveCongestionTrend = (payload, locationId) => ({
  type: RECEIVE_CONGESTION_TREND,
  locationId,
  payload,
})

export const receiveUserSettings = (payload) => ({
  type: RECEIVE_USER_SETTINGS,
  payload
})

export const receiveStationId = (payload) => ({
  type: RECEIVE_STATION_ID,
  payload
})

export const setUserSettings = (payload) => ({
  type: SET_USER_SETTINGS,
  payload
})

export const loadedDelayCertificates = payload => ({
  type: LOADED_DELAY_CERTIFICATES,
  delayCertificates: payload.delay_certificates,
})

export const loadedAnnouncement = payload => ({
  type: LOADED_ANNOUNCEMENT,
  announcement: payload.announcement,
})

export const changeTimetableCollapsed = (index, isCollapsed) => ({
  type: CHANGE_TIMETABLE_COLLAPSED,
  index,
  isCollapsed,
})

export const setTheme = (themeName) => ({
  type: SET_THEME,
  themeName,
})

export const setOs = (osName) => ({
  type: SET_OS,
  osName,
})

export const setPopinfoId = (popinfoId) => ({
  type: SET_POPINFO_ID,
  popinfoId,
})

export const receiveRestrooms = (payload) => ({
  type: RECEIVE_RESTROOMS,
  payload,
})

export const receiveTrainIconSettings = (payload) => ({
  type: RECEIVE_TRAIN_ICON_SETTINGS,
  payload
})

const fetchJSON = async (url, popinfoId = null) => {
  const fetchParams = {
    mode: 'cors'
  }
  if (popinfoId){
    fetchParams['headers'] = { ...fetchParams['headers'], 'x-popinfo-id': popinfoId }
  }
  const response = await fetch(url, fetchParams)
  const json = await response.json()
  return json
}

const putJSON = async (url, data, popinfoId = null) => {
  const fetchParams = {
    method: 'put',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(data)
  }
  if (popinfoId){
    fetchParams['headers'] = { ...fetchParams['headers'], 'x-popinfo-id': popinfoId }
  }
  const response = await fetch(url, fetchParams)
  return response
}

export const fetchLines = async () => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/line/lines.json?${+ new Date()}`)
export const fetchTrains = () => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/tid/trains.json?${+ new Date()}`)
// 開発時にローカル環境の json を利用する場合、下記を利用
// import debugTrainsData from '../../trains.json'
// export const fetchTrains = () => Promise.resolve(debugTrainsData)
export const fetchNotifications = async () => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/rss/train_infos.json?${+ new Date()}`)
export const fetchSingleTrain = (diaKind, interfaceNo, baseTime, trainNumber) => fetchJSON(`${API_BASE_URL}/diagram/train?dia_kind=${diaKind}&interface_no=${interfaceNo}&base_time=${baseTime}&train_number=${trainNumber}`)
export const fetchMaintenance = async () => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/config/maintenance.json?${+ new Date()}`)
export const fetchTrainIconSettings = async () => fetchJSON(`${CUSTOM_DATA_BASE_URL}/trainIcons/settings.json?${+ new Date()}`)

// StationViewのデータは現在本番にしか投げ込まれていないので
// API_BASE_URL をつかわずに本番URLをいったん固定で埋め込んでおく
export const fetchLocationData = async (stationId, locationId) => {
  return fetchJSON(`${STATION_VIEW_DATA_BASE_URL}/station_view/stations/${stationId}/locations/${locationId}.json?${+ new Date()}`)
}

export const fetchCurrentCongestionRate = async (stationId, locationId) => {
  return fetchJSON(`${STATION_VIEW_DATA_BASE_URL}/station_view/stations/${stationId}/locations/${locationId}/current_congestion_rate.json?${+ new Date()}`)
}

export const fetchCongestionTrend = async (stationId, locationId) => {
  return fetchJSON(`${STATION_VIEW_DATA_BASE_URL}/station_view/stations/${stationId}/locations/${locationId}/congestion_trend.json?${+ new Date()}`)
}

export const fetchStationDetail = async (diaKind, interfaceNo, stationId, currentTime) => fetchJSON(`${API_BASE_URL}/diagram/station?dia_kind=${diaKind}&interface_no=${interfaceNo}&station_id=${stationId}&current_time=${currentTime}`)
export const fetchUserSettings = async (popinfoId) => fetchJSON(`${API_BASE_URL}/user_setting`, popinfoId)
export const fetchDisplayStationId = async (popinfoId) => fetchJSON(`${API_LAMBDA_URL}/display_station_id`, popinfoId)
//export const fetchUserSettings = async (popinfoId) => fetchJSON(`${API_BASE_URL}/user_setting`, popinfoId)
export const putUserSettings = async (popinfoId, data) => putJSON(`${API_BASE_URL}/user_setting`, { user: data }, popinfoId)

export const fetchRestrooms = async () => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/washroom/vacanApiResult.json`)
